import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";
import config from "@/constants/Config";
import Cookies from "js-cookie";
import qs from "qs";

const options = {
  baseURL: config.API_URL,
};

const instance: AxiosInstance = axios.create(options);

// Add a request interceptor
instance.interceptors.request.use(
  (requestConfig: AxiosRequestConfig) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    requestConfig.paramsSerializer = (params: any) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
    if (requestConfig.url && requestConfig.url.indexOf("rest") !== -1) {
      const csrfName = sessionStorage.getItem("csrf_name");
      const csrf = csrfName ? Cookies.get(csrfName) : undefined;
      if (csrf !== undefined && csrf !== null) {
        requestConfig.headers["X-CSRF-TOKEN"] = csrf;
      }
    }

    if (config.MODE === "development") {
      requestConfig.withCredentials = true;
    }
    return requestConfig;
  },
  (requestError: AxiosError) => {
    return Promise.reject(requestError);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response && response.headers) {
      const headers = response.headers;

      const cacheControl = headers["cache-control"];
      if (
        cacheControl &&
        (cacheControl.includes("no-store") || cacheControl.includes("no-cache"))
      ) {
        const sntVersion = headers["snt-version"]
          ? headers["snt-version"]
          : null;
        if (
          sntVersion &&
          sessionStorage.getItem("NEWEST-SNT-VERSION") !== sntVersion
        ) {
          sessionStorage.setItem("NEWEST-SNT-VERSION", sntVersion);
        }
      } else {
        // cache response should be ignored
      }
    }
    return response;
  },
  (error: AxiosError) => {
    if (axios.isCancel(error)) {
      console.log("cancel");
    } else if (error.response && 401 === error.response.status) {
      const pathname = window.location.pathname;
      if (
        pathname !== "/login" &&
        pathname !== "/login/" &&
        pathname !== "/oauth2/authorize"
      ) {
        if (pathname === "/") {
          window.location.href = `/login`;
        } else {
          window.location.href = `/login?redirect_to=${encodeURIComponent(
            pathname + window.location.search
          )}`;
        }
      }
    }
    return Promise.reject(error);
  }
);

export const apiClient = instance;
